import { CALL_API } from "admin/middlewares/api";
import { Currencies } from "../../shared/dictionary/enums";

export const UC_REPORTS_LIST_CHANGE_PAGE = "UC_REPORTS_LIST_CHANGE_PAGE";

export function change_uc_reports_list_page(page) {
  return {
    type: UC_REPORTS_LIST_CHANGE_PAGE,
    page,
  };
}

export const UC_REPORTS_LIST_CHANGE_FILTER = "UC_REPORTS_LIST_CHANGE_FILTER";

export function change_uc_reports_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: UC_REPORTS_LIST_CHANGE_FILTER,
    filter,
  };
}

export const TAX_REPORTS_GET_REQUEST = "TAX_REPORTS_GET_REQUEST";
export const TAX_REPORTS_GET_SUCCESS = "TAX_REPORTS_GET_SUCCESS";
export const TAX_REPORTS_GET_ERROR = "TAX_REPORTS_GET_ERROR";

export function get_tax_reports(month, year) {
  let uri = `/api/admin/tax/report/byyearmonth?Year=${year}&Month=${month}&Currency=${Currencies.Sek}`;

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        TAX_REPORTS_GET_REQUEST,
        TAX_REPORTS_GET_SUCCESS,
        TAX_REPORTS_GET_ERROR,
      ],
    },
  };
}

export const EURO_TAX_REPORTS_GET_REQUEST = "EURO_TAX_REPORTS_GET_REQUEST";
export const EURO_TAX_REPORTS_GET_SUCCESS = "EURO_TAX_REPORTS_GET_SUCCESS";
export const EURO_TAX_REPORTS_GET_ERROR = "EURO_TAX_REPORTS_GET_ERROR";

export function get_euro_tax_reports(month, year) {
  let uri = `/api/admin/tax/report/byyearmonth?Year=${year}&Month=${month}&Currency=${Currencies.Eur}`;

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        EURO_TAX_REPORTS_GET_REQUEST,
        EURO_TAX_REPORTS_GET_SUCCESS,
        EURO_TAX_REPORTS_GET_ERROR,
      ],
    },
  };
}

export const TAX_TRANSFER_REQUEST = "TAX_TRANSFER_REQUEST";
export const TAX_TRANSFER_SUCCESS = "TAX_TRANSFER_SUCCESS";
export const TAX_TRANSFER_ERROR = "TAX_TRANSFER_ERROR";

export function transfer_tax(amount, bankPaymentId, currency) {
  let uri = `/api/admin/tax/transfer`;

  return {
    [CALL_API]: {
      endpoint: uri,
      method: "POST",
      data: {
        Amount: amount,
        BankPaymentId: bankPaymentId,
        Currency: currency,
      },
      authenticatedRequest: true,
      types: [TAX_TRANSFER_REQUEST, TAX_TRANSFER_SUCCESS, TAX_TRANSFER_ERROR],
    },
  };
}

export const MONTHLY_REPORTS_GET_REQUEST = "MONTHLY_REPORTS_GET_REQUEST";
export const MONTHLY_REPORTS_GET_SUCCESS = "MONTHLY_REPORTS_GET_SUCCESS";
export const MONTHLY_REPORTS_GET_ERROR = "MONTHLY_REPORTS_GET_ERROR";

export function get_monthly_reports(month, year, currency) {
  let uri =
    "/api/admin/reports/investor-tax?Year=" +
    year +
    "&Month=" +
    month +
    "&Currency=" +
    currency;

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        MONTHLY_REPORTS_GET_REQUEST,
        MONTHLY_REPORTS_GET_SUCCESS,
        MONTHLY_REPORTS_GET_ERROR,
      ],
    },
  };
}

export const BORROWER_DEPOTS_FETCH_REQUEST = "BORROWER_DEPOTS_FETCH_REQUEST";
export const BORROWER_DEPOTS_FETCH_SUCCESS = "BORROWER_DEPOTS_FETCH_SUCCESS";
export const BORROWER_DEPOTS_FETCH_ERROR = "BORROWER_DEPOTS_FETCH_ERROR";

export function get_borrower_depots() {
  let uri = "/api/admin/depotsummary/borrower-depots-with-balance";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        BORROWER_DEPOTS_FETCH_REQUEST,
        BORROWER_DEPOTS_FETCH_SUCCESS,
        BORROWER_DEPOTS_FETCH_ERROR,
      ],
    },
  };
}
